export default __webpack_public_path__ + "static/media/maintenance.db16282e.svg";